<template>
  <!-- Applica filtri se premuto INVIO. -->
  <v-card class="d-flex" color="#F0F0F0" @keyup.enter="applicaFiltri">

    <!-- Caricamento filtri dinamico (che abbiano visibilità = 1). -->
    <span v-for="(item, index) in lista_filtri_dettaglio" :key="item.id_filtro_dettaglio">
      <template v-if="item.visible == 1">
        
        <!-- Tipo TEXT_FIELD. -->
        <v-text-field v-if="item.tipo_oggetto == TipoOggetto.TEXT_FIELD"
          class="ml-3 mr-3"
          :label="item.des_filtro_dettaglio"
          v-model="item.valore"
        />

        <!-- Tipo DATA_QUERY / DATA_PICKER. -->
        <v-text-field v-if="item.tipo_oggetto == TipoOggetto.DATA_PICKER ||
                            item.tipo_oggetto == TipoOggetto.DATA_QUERY"
          type="date"
          class="ml-3 mr-3"
          :label="item.des_filtro_dettaglio"
          v-model="item.valore"
        />

        <!-- Tipo SELECT / MULTI_SELECT. -->
        <v-autocomplete v-if="item.tipo_oggetto == TipoOggetto.MULTI_SELECT ||
                              item.tipo_oggetto == TipoOggetto.SELECT"
          :multiple="item.tipo_oggetto == TipoOggetto.MULTI_SELECT"
          class="ml-3 mr-3"
          item-text="text"
          item-value="value"
          :label="item.des_filtro_dettaglio"
          :items="item.lista_query"
          :search-input.sync="input_autocomplete[index]"
          v-model="item.valore"
          @change="input_autocomplete[index] = '';"
        />
      </template>
    </span>

    <!-- Pulsante applica filtro. -->
    <v-tooltip bottom v-if="lista_filtri_dettaglio?.filter(e => e.visible == 1)?.length > 0">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small class="mt-5 ml-3 mr-3" v-on="on" v-bind="attrs"
          @click="applicaFiltri">
          <v-icon color="primary">mdi-filter-check</v-icon>
        </v-btn>
      </template>
      <span>Filtra</span>
    </v-tooltip>

    <!-- Pulsante pulisci filtro. -->
    <v-tooltip bottom v-if="lista_filtri_dettaglio?.filter(e => e.visible == 1)?.length > 0">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small class="mt-5 ml-3 mr-3" v-on="on" v-bind="attrs"
          @click="rimuoviFiltri">
          <v-icon color="error">mdi-filter-remove</v-icon>
        </v-btn>
      </template>
      <span>Pulisci</span>
    </v-tooltip>

    <v-spacer/>

    <!-- Set di filtri. -->
    <v-autocomplete
      class="ml-3 mr-3"
      style="max-width: 150px"
      label="Set di filtri"
      item-value="id_filtro"
      item-text="des_filtro"
      :items="lista_set_di_filtri"
      v-model="id_filtro_sel"
      @change="aggiornaVisualizzazioneFiltri(computeIsDefault);
               applicaFiltri();">
        <template v-slot:item="{ item }">
          <div style="text-align: left">
            {{ item.des_filtro }}
          </div>
        </template>
    </v-autocomplete>
    
  </v-card>
</template>

<script>
import moment from 'moment';
const TipoOggetto = Object.freeze({TEXT_FIELD: 0, DATA_PICKER: 1, DATA_QUERY: 2,  MULTI_SELECT: 3, SELECT: 4});

export default {
  name: "InputFiltri",
  components: {},
  props: {
    lista_filtri: { type: Array, default: ()=>[] },
    key_update: {type: Boolean, default: null},
    id_session_key: { type: String, default: null }
  },

  data() {
    return {
      // Costanti.
      TipoOggetto,

      // Variabili di supporto.
      caricamento_dati: false,
      id_filtro_sel: null,

      // Array. 
      lista_set_di_filtri: [],
      lista_filtri_dettaglio: [],
      input_autocomplete: []
    };
  },

  methods: {
    aggiornaVisualizzazioneFiltri(get_session = false) {
      
        // Aggiorna i filtri dettaglio.
        this.lista_filtri_dettaglio = [];
        
        let filtri_copy;
        
        let set_di_filtri_sel = this.lista_filtri.find(e => { return e.id_filtro === this.id_filtro_sel;})
        if(set_di_filtri_sel) {
            set_di_filtri_sel = JSON.parse(JSON.stringify(set_di_filtri_sel));
            filtri_copy = set_di_filtri_sel.filtri_dettaglio;
        }
        
        if(filtri_copy) this.lista_filtri_dettaglio = [...filtri_copy];

        // Se il parametro chiede di prendere la sessione, lo fa e aggiorna i filtri.
        if(get_session) {
          let sessione_filtri = JSON.parse(this.getSessione());

          // Assegna per ogni filtro il valore salvato.
          if(sessione_filtri) {
            this.lista_filtri_dettaglio.forEach((e) => {
              let filtro_sessione = sessione_filtri.find(i => i.id_filtro_dettaglio == e.id_filtro_dettaglio);
              e.valore = filtro_sessione ? filtro_sessione.valore : e.valore;
            });
          }
        }

        // Ordine di apparizione (da sinistra a destra).
        this.lista_filtri_dettaglio.sort((a, b) => a.ordine - b.ordine);

        // Ordina i valori della multi-select dalla A alla Z.
        this.lista_filtri_dettaglio.forEach(e => {
          if(e.lista_query) e.lista_query.sort((a, b) => (a.text ? a.text : "").localeCompare(b.text ? b.text : ""));
        });

        this.convertiDataQuery();
    },

    applicaFiltri() {
      // Salva la sessione attuale.
      this.setSessione(JSON.stringify(this.lista_filtri_dettaglio));

      // Triggera la funzione del componente padre per applicare i filtri.
      this.$emit('applica_filtri', this.computeApplicaFiltri);
    },

    applicaFiltriSessione() {
        // "filtri_query" del componente padre viene aggiornato con i filtri salvati nella sessione.
        let sessione_filtri = this.getSessione();
        if(sessione_filtri) {
          this.lista_filtri_dettaglio = JSON.parse(sessione_filtri);
          this.$emit('applica_filtri_sessione', this.computeApplicaFiltri);
        }
    },

    // Converti il valore e l'oggetto di DATA_QUERY in DATA_PICKER.
    convertiDataQuery() {
      this.lista_filtri_dettaglio.forEach(e => {
        if(e.tipo_oggetto == TipoOggetto.DATA_QUERY) {
          e.tipo_oggetto = TipoOggetto.DATA_PICKER;
          if(e.valore) {
            var data_query = e.valore.split("/");

            if(data_query.length == 2) {
              let unita_tempo;
              switch(data_query[1]) {
                case "DAY":
                  unita_tempo = "days";
                  break;
                case "MONTH": case "START_MONTH": case "END_MONTH":
                  unita_tempo = "months";
                  break;
                case "YEAR": case "START_YEAR": case "END_YEAR":
                  unita_tempo = "years";
                  break;
              }
              
              e.valore = moment().add(Number(data_query[0]), unita_tempo).format("YYYY-MM-DD");

              switch(data_query[1]) {
                case "START_MONTH":
                  e.valore = moment(e.valore).startOf("month").format("YYYY-MM-DD");
                  break;
                case "END_MONTH": 
                  e.valore = moment(e.valore).endOf("month").format("YYYY-MM-DD");
                  break;
                case "START_YEAR":
                  e.valore = moment(e.valore).startOf("year").format("YYYY-MM-DD");
                  break;
                case "END_YEAR": 
                  e.valore = moment(e.valore).endOf("year").format("YYYY-MM-DD");
                  break;
              }
            }
          } else e.valore = moment().format("YYYY-MM-DD");
            
        }
      });
    },

    // Converti i valori della multi-select (stringa -> lista).
    convertiMultiSelectList() {
      this.lista_filtri_dettaglio.forEach(e => {
        if(e.tipo_oggetto == TipoOggetto.MULTI_SELECT) {
          if(e.valore) {
            // Per effettuare il metodo "split()" dobbiamo assicurarci che il valore sia stringa.
            // Quando passato dalla sessione, è array. Se è un valore preimpostato in "GestioneFiltri" è stringa.
            if(typeof(e.valore) == "string")
              e.valore = e.valore.split(",");
          } else e.valore = [];
        }
      });   
    },

    getSessione() {
      // Ritorna l'oggetto salvato dall'ultima sessione con l'id corrispondente.
      let key = (this.id_session_key ? "filtro_sessione_" + this.id_session_key : "");
      return key ? sessionStorage.getItem(key) : null;
    },

    rimuoviFiltri() {
      // Pulisci i filtri immessi dall'utente ignorando quelli invisibili.
      this.lista_filtri_dettaglio.forEach(e => { if(e.visible == 1) e.valore = null});
    },

    setSessione(valore) {
      // Salva la sessione solo col set di filtri "Default" e solo se dal padre è stato passato l'id_sessione.
      if(this.computeIsDefault) {
        let key = (this.id_session_key ? "filtro_sessione_" + this.id_session_key : "");
        if (key) sessionStorage.setItem(key, valore);
      }
    }
  },

  mounted() {
    // NOTA: si da per scontato che al primo caricamento di InputFiltri, "Default" sia il set di filtri caricato per primo.
    this.applicaFiltriSessione();
  },

  computed: {
    computeApplicaFiltri() {
      // Copia i filtri da mandare e, qualora Array(), converte "valore" in stringa.
      let lista_filtri_dettaglio_copy = JSON.parse(JSON.stringify(this.lista_filtri_dettaglio));
     
      lista_filtri_dettaglio_copy.forEach(e => {
        if(e.tipo_oggetto == TipoOggetto.MULTI_SELECT)
          if(e.valore) e.valore = e.valore.toString();
      });

      return lista_filtri_dettaglio_copy;
    },

    computeIsDefault() {
      // Controlla se il set di filtri attualmente selezionato sia "Default".
      let item_set_filtro = this.lista_set_di_filtri.find(e =>{ return e.id_filtro === this.id_filtro_sel; });
      if(item_set_filtro) return item_set_filtro.des_filtro === "Default";
      else return false;
    }
  },

  watch: {
    lista_filtri: {
      handler() {
        // Aggiorna la lista di set filtri.
        if(this.lista_set_di_filtri.length == 0) {
          this.lista_set_di_filtri = [...this.lista_filtri];

          // Se nessun filtro è selezionato, prende quello default.
          if(!this.id_filtro_sel && this.lista_set_di_filtri.length > 0)
              this.id_filtro_sel = this.lista_set_di_filtri.find(e => { return e.des_filtro === "Default"; }).id_filtro;
          
          // NOTA: si da per scontato che al primo caricamento di InputFiltri, "Default" sia il set di filtri caricato per primo.
          this.aggiornaVisualizzazioneFiltri(true);
          this.convertiMultiSelectList();
        }
      },
      deep: true,
    },

    key_update: {
      handler() {
        this.lista_set_di_filtri = [...this.lista_filtri];

        // Se nessun filtro è selezionato, prende quello default.
        if(!this.id_filtro_sel && this.lista_set_di_filtri.length > 0)
            this.id_filtro_sel = this.lista_set_di_filtri.find(e => { return e.des_filtro === "Default"; }).id_filtro;
        
        this.aggiornaVisualizzazioneFiltri(this.computeIsDefault);
        this.convertiMultiSelectList();
      }
    },

    id_session_key: {
      handler() {
        // Se aggiornato il riferimento della sessione dei filtri, li ricarica e li manda al componente padre.
        // NOTA: si da per scontato che in InputFiltri, "Default" sia il set di filtri caricato per primo.
        this.applicaFiltriSessione();
      }
    }
  }
};
</script>

<style scoped>
  .v-autocomplete, .v-text-field {
    max-width: 250px;
  }
</style>
